module.exports = __webpack_public_path__ + "img/page3-3.d1550d3e.png";